(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["craft-pricing-calculator"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pricing-tool]').forEach((tool)=>{const form=tool.querySelector('form'),price=tool.querySelector('[data-price]'),summary=tool.querySelector('[data-summary]'),cost=tool.querySelector('[data-cost]'),fees=tool.querySelector('[data-fees]'),profit=tool.querySelector('[data-profit]'),num=(key)=>Math.max(0,Number.parseFloat(form.elements[key].value)||0),calc=()=>{const f=new Intl.NumberFormat(undefined,{style:'currency',currency:form.elements.currency.value,maximumFractionDigits:2}),making=num('materials')+num('hours')*num('hourlyRate')+num('overhead'),rate=(num('platformFee')+num('paymentFee')+num('profitMargin'))/100,base=making+num('fixedFee');if(rate>=.95){price.textContent='Check your percentages';summary.textContent='Selling fees and desired profit need to total less than 95%.';cost.textContent=f.format(making);fees.textContent='—';profit.textContent='—';return}const selling=base/(1-rate),saleFees=selling*((num('platformFee')+num('paymentFee'))/100)+num('fixedFee'),targetProfit=selling*(num('profitMargin')/100);price.textContent=f.format(selling);summary.textContent='This price covers your costs, estimated fees and target profit.';cost.textContent=f.format(making);fees.textContent=f.format(saleFees);profit.textContent=f.format(targetProfit)};form.addEventListener('submit',(event)=>{event.preventDefault();calc()});form.addEventListener('input',calc);form.addEventListener('change',calc);calc()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etsy-fee-calculator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-etsy-fee-calculator]').forEach((calculator) => {
    const form = calculator.querySelector('form');
    const presets = {
      us: { currency: 'USD', locale: 'en-US', transaction: 6.5, processing: 3, processingFixed: 0.25, listing: 0.20, feeTax: 0 },
      uk: { currency: 'GBP', locale: 'en-GB', transaction: 6.5, processing: 4, processingFixed: 0.20, listing: 0.16, feeTax: 0 },
      ie: { currency: 'EUR', locale: 'en-IE', transaction: 6.5, processing: 4, processingFixed: 0.30, listing: 0.20, feeTax: 0 },
      custom: { currency: 'USD', locale: 'en-US' }
    };
    let activePreset = presets.us;
    const number = (name) => Math.max(0, Number.parseFloat(form.elements[name].value) || 0);
    const formatter = () => new Intl.NumberFormat(activePreset.locale, { style: 'currency', currency: activePreset.currency });
    const draw = () => {
      const price = number('price');
      const shipping = number('shippingCharged');
      const orderTotal = price + shipping;
      const transaction = orderTotal * number('transaction') / 100;
      const processing = orderTotal * number('processing') / 100 + number('processingFixed');
      const ads = orderTotal * number('ads') / 100;
      const otherOrderFee = orderTotal * number('otherOrderFee') / 100;
      const platformBeforeTax = transaction + processing + ads + otherOrderFee + number('listing');
      const platformFees = platformBeforeTax * (1 + number('feeTax') / 100);
      const costs = number('postageCost') + number('costs');
      const profit = orderTotal - platformFees - costs;
      const margin = orderTotal ? profit / orderTotal * 100 : 0;
      const hourly = number('hours') ? profit / number('hours') : 0;
      const rate = (number('transaction') + number('processing') + number('ads') + number('otherOrderFee')) / 100;
      const taxMultiplier = 1 + number('feeTax') / 100;
      const fixedFees = (number('processingFixed') + number('listing')) * taxMultiplier;
      const denominator = 1 - rate * taxMultiplier;
      const suggestedOrderTotal = denominator > 0 ? (number('targetProfit') + costs + fixedFees) / denominator : 0;
      const suggestedPrice = Math.max(0, suggestedOrderTotal - shipping);
      const money = formatter();
      calculator.querySelector('[data-profit]').value = money.format(profit);
      calculator.querySelector('[data-profit]').textContent = money.format(profit);
      calculator.querySelector('[data-order-total]').textContent = money.format(orderTotal);
      calculator.querySelector('[data-platform-fees]').textContent = money.format(platformFees);
      calculator.querySelector('[data-cost-total]').textContent = money.format(costs);
      calculator.querySelector('[data-margin]').textContent = margin.toFixed(1) + '%';
      calculator.querySelector('[data-hourly]').textContent = money.format(hourly);
      calculator.querySelector('[data-suggested-price]').textContent = money.format(suggestedPrice);
    };
    const applyPreset = () => {
      activePreset = presets[form.elements.country.value];
      if (form.elements.country.value !== 'custom') {
        ['transaction', 'processing', 'processingFixed', 'listing', 'feeTax'].forEach((name) => {
          form.elements[name].value = activePreset[name];
        });
      }
      draw();
    };
    form.addEventListener('input', draw);
    form.elements.country.addEventListener('change', applyPreset);
    calculator.querySelector('[data-reset]').addEventListener('click', () => { form.reset(); applyPreset(); });
    applyPreset();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-tag-generator"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-gift-tags]').forEach((tool)=>{const to=tool.querySelector('[name="to"]');const from=tool.querySelector('[name="from"]');const style=tool.querySelector('[name="style"]');const sheet=tool.querySelector('[data-sheet]');const update=()=>{tool.querySelectorAll('[data-to]').forEach((tag)=>{tag.textContent=to.value||'Someone special'});tool.querySelectorAll('[data-from]').forEach((tag)=>{tag.textContent=from.value||'From me'});sheet.dataset.style=style.value};to.addEventListener('input',update);from.addEventListener('input',update);style.addEventListener('change',update);tool.querySelector('[data-print]').addEventListener('click',()=>window.print());update()});

  } catch(e) { console.error(e); }
})();
})();
